import React, { useState } from 'react';
import { toast } from 'sonner';
import { adminApi, apiError } from '../../lib/adminApi';
import { CalendarDays, Loader2 } from 'lucide-react';

const inp = 'w-full bg-black border border-white/15 rounded-lg px-3 py-2.5 text-white text-sm outline-none focus:border-red-500';
const tomorrow = () => new Date(Date.now() + 86400000).toLocaleDateString('en-CA', { timeZone: 'Europe/Athens' });

export default function SocialWeekly({ onCreated }) {
  const [f, setF] = useState({ start_date: tomorrow(), time: '19:00', reel_time: '13:00', include_reels: true, style: 'realistic', language: 'el', auto_schedule: true, targets: ['instagram', 'facebook'] });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const toggleTarget = (t) => setF({ ...f, targets: f.targets.includes(t) ? f.targets.filter((x) => x !== t) : [...f.targets, t] });

  const run = async () => {
    if (f.auto_schedule && f.targets.length === 0) { toast.error('Scegli almeno Instagram o Facebook'); return; }
    setBusy(true);
    try {
      const { data } = await adminApi.post('/admin/social/weekly', f);
      onCreated(data.items);
      toast.success(f.include_reels ? '7 foto + 7 Reel in creazione: foto in 1-3 min, video in 15-40 min' : '7 post in creazione: pronti in 1-3 minuti');
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };

  return (
    <div className="bg-[#0d0d0d] border border-white/10 rounded-xl p-5 space-y-4" data-testid="social-weekly">
      <div>
        <div className="flex items-center gap-2"><CalendarDays className="text-red-500" size={18} /><h3 className="text-white font-bold">Pacchetto settimanale AI</h3></div>
        <p className="text-white/40 text-xs mt-1">7 foto (Fragola, Banana, Menta, Arancia, Mela, Mirtillo in arrivo, Mix Box) + opzionale un Reel al giorno.</p>
      </div>
      <div className="grid sm:grid-cols-4 gap-3">
        <input type="date" data-testid="weekly-start-date" className={inp} value={f.start_date} onChange={set('start_date')} />
        <input type="time" data-testid="weekly-time" className={inp} value={f.time} onChange={set('time')} />
        <select data-testid="weekly-style" className={inp} value={f.style} onChange={set('style')}>
          <option value="realistic">Realistico</option><option value="graphic">Grafico</option>
        </select>
        <select data-testid="weekly-language" className={inp} value={f.language} onChange={set('language')}>
          <option value="el">Greco</option><option value="it">Italiano</option><option value="en">Inglese</option>
        </select>
      </div>
      <div className="flex flex-wrap items-center gap-5 text-sm text-white/70">
        <label className="flex items-center gap-2"><input type="checkbox" data-testid="weekly-include-reels" checked={f.include_reels}
          onChange={(e) => setF({ ...f, include_reels: e.target.checked })} className="accent-red-600" /> Anche un Reel video al giorno (consuma più crediti)</label>
        {f.include_reels && (
          <label className="flex items-center gap-2">Ora Reel
            <input type="time" data-testid="weekly-reel-time" className="bg-black border border-white/15 rounded-lg px-2 py-1.5 text-white text-sm [color-scheme:dark]"
              value={f.reel_time} onChange={set('reel_time')} /></label>
        )}
      </div>
      <div className="flex flex-wrap items-center gap-5 text-sm text-white/70">
        <label className="flex items-center gap-2"><input type="checkbox" data-testid="weekly-auto-schedule" checked={f.auto_schedule}
          onChange={(e) => setF({ ...f, auto_schedule: e.target.checked })} className="accent-red-600" /> Programma in automatico (ora greca)</label>
        {['instagram', 'facebook'].map((t) => (
          <label key={t} className="flex items-center gap-2 capitalize"><input type="checkbox" data-testid={`weekly-target-${t}`}
            checked={f.targets.includes(t)} onChange={() => toggleTarget(t)} className="accent-red-600" /> {t}</label>
        ))}
      </div>
      <button data-testid="weekly-submit" onClick={run} disabled={busy}
        className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-500 disabled:opacity-50 text-white font-bold text-sm px-5 py-2.5 rounded-lg transition-colors">
        {busy ? <Loader2 size={16} className="animate-spin" /> : <CalendarDays size={16} />} Genera la settimana
      </button>
    </div>
  );
}
